<template>
    <a :href="routeWithIds" title="Comparer" class="ec-header-button ec-compare-top-icon">
        <i class="ec-icon ec-icon-compare"></i>
        <span class="badge badge-warning ec-compare-top-icon-count">{{ bikeIds.length || '' }}</span>
    </a>
</template>

<style lang="scss" type="text/scss">
    @import "../../../sass/variables";
    @import "../../../sass/mixins";

    .ec-compare-top-icon {
        position: relative;

        .ec-compare-top-icon-count {
            position: absolute;
            right: -$grid-gutter-width/2;
            top: -$grid-gutter-width/2;
            font-size: $ec-font-size-small;
            background-color: $ec-primary-color;
            @include transition(all 0.5s ease);
        }

        &:hover {
            .ec-compare-top-icon-count {
                background-color: $ec-color-white;
                color: $ec-primary-color;
            }
        }
    }
</style>

<script type="text/babel">
    export default {
        props: ['route'],

        data: function () {
            return {
            };
        },

        computed: {
            bikeIds: function() {
                return this.$store.state.comparedBikeIds;
            },

            routeWithIds: function() {
                if (!this.bikeIds || !this.bikeIds.length) {
                    return this.route;
                }

                return this.route + '-' + _.join(this.bikeIds, '-')
            }
        }
    }
</script>